import React from "react";
import TitleHeader from "../../components/Common/TitleHeader";
import useResponsive from "../../hooks/useResponsive";
import { Divider, Tabs } from "antd";
import { BIBLE_TABS_DATA } from "./BIBLE_TABS_DATA";
import { Helmet } from "react-helmet";

const BibleYear = () => {
  const { isMobile } = useResponsive();
  return (
    <div>
      <Helmet>
        <title>อ่านพระคัมภีร์ใน 1 ปี - Scripture Union Thailand</title>
        <meta
          name="description"
          content="SU THAILAND ทำพันธกิจร่วมกับคริสตจักรและโรงเรียน เพื่อให้เด็กเยาวชนและครอบครัว ได้ยินข่าวประเสริฐของพระเจ้า"
        />
      </Helmet>
      <TitleHeader en="A Bible in a year" th="อ่านพระคัมภีร์ใน 1 ปี" center />
      <Divider />
      <div style={{ padding: "0px 20px" }}>
        <Tabs
          defaultActiveKey="1"
          tabPosition={isMobile ? "top" : "left"}
          items={BIBLE_TABS_DATA.map((data) => {
            return {
              label: data.label,
              key: data.label,
              children: data.component,
            };
          })}
        />
      </div>
    </div>
  );
};

export default BibleYear;
